// The quiet icon button for undo and redo: grey ink, darker on hover.
export const HistoryButtonClass =
  "btn btn-sm shadow-none d-flex align-items-center justify-content-center rounded-1 p-1-5 lh-1 border border-white bg-transparent text-body hover-bg-light";
